<template>
  <div>
    <base-modal
      :is-show="isShowConfirm"
      size="sm"
      @close="closeConfirmModal"
      @confirm="resetPassword"
      @cancel="cancelReset"
    >
      <template slot="header">{{ $t('src/components/userresetpassword.2155') }}</template>
      <template slot="body">
        <base-spinner v-if="loading"></base-spinner>
        <div v-else-if="userId" class="text-center">
          <p>{{ $t('src/components/userresetpassword.7451') }}</p>
          <p>{{ fullName }}?</p>
        </div>
      </template>
    </base-modal>
    <base-modal :is-show="isShowRegToken" :mode="'message'" size="lg" @close="saveReset">
      <template slot="header">{{ $t('src/components/userresetpassword.7888') }}</template>
      <template slot="body">
        <div v-if="fullRegLink" class="text-center">
          <p>
            <strong>{{ fullRegLink }}</strong>
          </p>
          <p>
            {{ $t('src/components/userresetpassword.3198') }}<i>{{ fullName }}</i
            >{{ $t('src/components/userresetpassword.7786') }}
          </p>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import { fullName } from '@/mixins/full-name.js'
import { userStatus } from '@/main.config.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'UserResetPassword',
  mixins: [fullName, systemUnavailable],
  components: {
    BaseSpinner: () => import('@/base/BaseSpinner.vue'),
    BaseModal: () => import('@/base/BaseModal.vue')
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isShowConfirm: false,
    regtoken: null,
    isShowRegToken: false,
    loading: false
  }),
  mounted() {
    this.isShowConfirm = true
  },
  computed: {
    userId() {
      return this.user.id
    },
    isHimself() {
      return this.$store.getters.IS_HIMSELF(this.userId)
    },
    fullName() {
      return this.getFullName(this.user)
    },
    fullRegLink() {
      if (!this.regtoken) {
        return false
      }

      return window.location.protocol + '//' + window.location.host + this.regLink
    },
    regLink() {
      if (!this.regtoken) {
        return false
      }
      return '/registration/' + this.regtoken
    }
  },
  methods: {
    closeConfirmModal() {
      this.isShowConfirm = false
    },
    showRegTokenModal() {
      this.isShowRegToken = true
    },
    resetPassword() {
      this.loading = true
      http
        .patch('/users/' + this.userId, {
          status: userStatus.unregistered,
          user_roles: this.user.user_roles
        })
        .then(response => response.data)
        .then(user => {
          this.regtoken = user.regtoken
          if (!this.isHimself) {
            this.showRegTokenModal()
          } else {
            this.redirectToRegLink()
          }
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          console.error(error)
        })
        .finally(() => {
          this.loading = false
          this.closeConfirmModal()
        })
    },
    cancelReset() {
      this.$emit('cancel')
    },
    saveReset() {
      this.$emit('reset', this.user)
    },
    redirectToRegLink() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push(this.regLink)
      })
    }
  }
}
</script>
